import React, { Fragment, ReactNode } from 'react';
import styles from './InfoCard.module.css';

export interface Props {
  actionItems?: ReactNode[];
  image?: string;
  title: ReactNode;
  highlight: ReactNode;
  price?: number;
  items: [ReactNode, ReactNode?][];
}

export default function InfoCard(props: Props) {
  return (
    <div className={styles.item}>
      <div className={styles.itemImage}>
        <img src={props.image} />
      </div>

      <div className={styles.itemContent}>
        <div className={styles.itemContentTop}>
          <h3>{props.title}</h3>
          <span className={styles.box}>{props.highlight}</span>
        </div>

        {props.items.map((it, idx) => (
          <p key={idx}>
            {it[0]}
            {it[1] === undefined ? (
              ''
            ) : (
              <>
                : <b>{it[1]}</b>
              </>
            )}
          </p>
        ))}
        {props?.price && (
          <div className={styles.price}>
            ${new Intl.NumberFormat('es-CO').format(props.price)}
          </div>
        )}
      </div>
      <div className={styles.itemActions}>
        {props.actionItems?.map((it, idx) => (
          <Fragment key={idx}>{it}</Fragment>
        ))}
      </div>
    </div>
  );
}
